import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchState } from './searchTypes';
import { getInitialSessionOnClientEntry } from '../../helpers/sessionHelper';
import { replaceSpaceChar } from '../../helpers/formHelper';

const initialState = (): SearchState => {
  const restoredState = getInitialSessionOnClientEntry(SUB_PATH);
  return {
    ...restoredState.search,
  };
};

const searchSlice = createSlice({
  name: 'search',
  initialState: initialState(),
  reducers: {
    updatePostCodeInSearch: (state, action: PayloadAction<string>) => {
      state.postCode = CSS_CONFIG.FORMATS.useZipCodeSpaceTrim
        ? replaceSpaceChar(action.payload.toUpperCase())
        : action.payload.toUpperCase();
    },
    updateCountryStateInSearch: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    updateAddressInSearch: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    updateCityInSearch: (state, action: PayloadAction<string>) => {
      state.city = action.payload;
    },
  },
});

export const {
  updatePostCodeInSearch,
  updateCountryStateInSearch,
  updateAddressInSearch,
  updateCityInSearch,
} = searchSlice.actions;

export default searchSlice.reducer;
